import { Base64 } from 'js-base64';

import { ICredentials } from '../models/ICredentials';

export const decryptCredentials = (credentials: string): ICredentials => {
  return JSON.parse(Base64.decode(credentials)) as ICredentials;
};
